<template>
  <div
    class="experience--provider-image"
    :class="{ 'provider--horizontal': horizontal }"
  >
    <div class="experience--provider-image-container">
      <LadImage
        v-if="!!exLocal.profile_picture.src"
        :src="exLocal.profile_picture.src"
        :srcset="exLocal.profile_picture.srcset"
        :max-width="200"
      />
    </div>

    <div v-if="showRate" class="experience--provider-image-bottom">
      <slot name="bottom-before"></slot>

      <el-rate
        v-if="exLocal.name && exReviews.count"
        v-model="exReviews.value"
        show-score
        :score-template="exReviews.value.toPrecision(3)"
        disabled
        aria-label="reviews"
      />

      <slot name="bottom-after">
        <p
          v-html="
            $tc(`${base}.comments`, exReviews.count, {
              comments: exReviews.count,
            })
          "
        ></p>
      </slot>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadProviderImage',
  components: {
    LadImage: () =>
      import(
        /* webpackChunkName: "lad-image" */ '@/components/frontends/Image/index'
      ),
  },
  props: {
    // eslint-disable-next-line vue/no-boolean-default
    showRate: { type: Boolean, default: true },
    horizontal: { type: Boolean, default: false },
  },
  data() {
    return {
      base: 'experience.provider',
      baseReview: 'experience.navbar.review',
    }
  },
  computed: {
    ...mapState('experience', {
      exLocal: 'local',
      exReviews: 'reviews',
    }),
  },
}
</script>

<style lang="scss">
.experience--provider-image {
  // display: grid;
  grid-template-columns: 1fr;
  text-align: center;

  &-container {
    // & > div {
    position: relative;
    padding-top: 100%;
    width: 100%;

    img {
      border-radius: 100%;
      position: absolute;
      height: 90% !important;
      width: 90%;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
    // }
  }

  &-bottom {
    .el-rate {
      margin-top: 0.8em;
    }

    p {
      font-size: 0.9em;
    }
  }

  &.provider--horizontal {
    display: grid;
    grid-template-columns: auto 1fr;
    text-align: left;

    .el-rate {
      margin-top: 0;
    }

    .experience--provider-image-container {
      width: 60px;
      height: 60px;
    }
  }
}
</style>
